import { render, staticRenderFns } from "./JDFilter.vue?vue&type=template&id=44f38ade&scoped=true&"
import script from "./JDFilter.vue?vue&type=script&lang=js&"
export * from "./JDFilter.vue?vue&type=script&lang=js&"
import style0 from "./JDFilter.vue?vue&type=style&index=0&id=44f38ade&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f38ade",
  null
  
)

export default component.exports